module.exports = __webpack_public_path__ + "media/images/app/about/dafi-bcc504950b8feb857fc964654aff8ab8.webp";